<template>
  <section class="hospital-onboarding">
    <Breadcrumbs :items="breadcrumbs" />
    <rp-hospital-by-country
      v-model="model"
      :countries="countries"
      :hospitals="hospitals"
      @hospitalFound="onHospitalFound"
      @hospitalNotFound="onHospitalNotFound" />
    <rp-overlay :active="showOverlay">
      <rp-confirm
        icon="done"
        messageText="Hospital added successfully. Would you like to add another?"
        btnConfirmText="Yes"
        btnCancelText="No"
        :confirm="onAddAnother"
        :cancel="onAllDone" />
    </rp-overlay>
  </section>
</template>

<script>
  import page from '@/mixins/page'
  import Overlay from 'raypro_ui/src/components/ui/Overlay'
  import Confirm from 'raypro_ui/src/components/ui/DeleteConfirm'
  import Breadcrumbs from '@/components/Breadcrumbs'
  import HospitalByCountry from 'raypro_ui/src/components/ui/forms/HospitalLookupByCountry'

  import {mapGetters} from 'vuex'
  import {getCountries} from 'raypro_ui/src/api/countries'
  import {getHospitalsWithoutPagination} from 'raypro_ui/src/api/hospitals'
  import {addHospitalToSurgeon} from 'raypro_ui/src/api/users'

  export default {
    mixins: [page],

    components: {
      Breadcrumbs,
      'rp-overlay': Overlay,
      'rp-confirm': Confirm,
      'rp-hospital-by-country': HospitalByCountry,
    },

    data() {
      return {
        model: {country: '', hospital: ''},
        countries: [],
        hospitals: [],
        showOverlay: false,
        title: 'Find or Add Hospital',
        breadcrumbs: [{label: 'Find or Add Your Hospital'}],
      }
    },

    mounted() {
      getCountries().then(({data}) => {
        this.countries = data.map((country) => {
          return {
            id: country.id,
            name: country.name,
            code: country.code,
          }
        })
      })

      getHospitalsWithoutPagination().then(({data}) => {
        this.hospitals = data
      })
    },

    computed: {
      ...mapGetters(['authUser']),
    },

    methods: {
      onHospitalFound() {
        addHospitalToSurgeon({
          userId: this.authUser.id,
          hospitalId: this.model.hospital.id
        }).then(() => {
          this.showOverlay = true
        })
      },

      onHospitalNotFound() {
        this.$router.push({name: 'add-hospital'})
      },

      onAddAnother() {
        this.showOverlay = false
        this.model = {country: '', hospital: ''}
      },

      onAllDone() {
        this.showOverlay = false
        this.$router.push({name: 'Overview'})
      },
    },
  }
</script>

<style lang="sass" scoped>
  @import 'raypro_ui/src/styles/base/_variables.sass'

  .hospital-onboarding
    font-weight: bold
    font-family: 'Stolzl'

    .hospital-lookup-form
      width: 100%
      max-width: 1200px
      border-radius: 20px

      /deep/ .btn
        font-weight: normal
        font-family: 'Stolzl'
        border-radius: 5px
        &.is-secondary
          border: 1px solid $color-text

      /deep/ h3
        font-size: large
        text-transform: none

      /deep/ .input-wrapper
        .input-label
          font-size: 14px

      /deep/ .dropdown__relative-wrapper
        .dropdown
          &.scrollable
            max-height: 196px
</style>



// WEBPACK FOOTER //
// src/components/pages/Hospitals/HospitalOnboarding.vue